import { render } from "./EditOffer.vue?vue&type=template&id=1355dd92"
import script from "./EditOffer.vue?vue&type=script&lang=js"
export * from "./EditOffer.vue?vue&type=script&lang=js"
script.render = render

export default script